import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CancelRegularReport from './cancel-regular-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CancelRegularReport {...validProps} />;
}

SvgComponent.iconName = 'cancelRegularReport';

export const CancelRegularReportIcon = svgIconWrapper(SvgComponent);
